import apiClient from '../helper/apiClient';
import { SERVICE_ROUTES } from '../constants/service.constants';

export const postSnowApi = async payload => {
  const httpClient = apiClient.getZoomAppBffInstance();
  return httpClient.post(SERVICE_ROUTES.FETCH_SNOW_SERVICE_ROUTE, payload);
};
